import { DropdownMenuTrigger } from '@radix-ui/react-dropdown-menu';
import { Table } from '@tanstack/react-table';
import { Columns3Icon, Settings2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';

export function DataTableViewOptions<TData>({
  table,
  variant = 'button',
}: {
  table: Table<TData>;
  variant?: 'button' | 'icon';
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {variant === 'icon' ? (
          <Button
            variant="secondary"
            size="icon-sm"
            style={{ borderRadius: 8 }}
          >
            <Columns3Icon />
            <span className="tw:sr-only">Toggle columns</span>
          </Button>
        ) : (
          <Button
            variant="outline"
            size="sm"
            className="tw:ml-auto tw:hidden tw:h-8 tw:sm:flex"
          >
            <Settings2 />
            View
          </Button>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="tw:min-w-[150px] tw:max-w-[250px]"
      >
        <DropdownMenuLabel>Toggle columns</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {table
          .getAllColumns()
          .filter(
            (column) =>
              typeof column.accessorFn !== 'undefined' && column.getCanHide(),
          )
          .map((column) => {
            return (
              <DropdownMenuCheckboxItem
                key={column.id}
                className="capitalize"
                checked={column.getIsVisible()}
                onCheckedChange={(value) => column.toggleVisibility(!!value)}
                onSelect={(e) => e.preventDefault()}
              >
                {/* @ts-ignore */}
                {column.columnDef.meta?.getName() ?? column.id}
              </DropdownMenuCheckboxItem>
            );
          })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
